
export default function Buf(opts) {
    const buf = Buffer.alloc(opts.size);

    if (opts.data) {
        opts.data.copy(buf, 0, 0, opts.size);
    }

    return {
        buf: buf,

        read(address) {
            const val = buf.readUInt8(address);
            return val;
        },

        write(address, value) {
            buf[address] = value;
        },

        reset() {
            //buf.fill(0);
        }
    };
}


// WEBPACK FOOTER //
// ./src/emu/BufferAdapter.js